import Carousel, { slidesToShowPlugin, autoplayPlugin } from "./react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import clientLogo1 from "../../images/v2/client-logos/evorich.png";
import clientLogo2 from "../../images/v2/client-logos/sd_logo_black.png";
import clientLogo3 from "../../images/v2/client-logos/crowe_horwath_llp_logo.png";
import clientLogo4 from "../../images/v2/client-logos/Logo-Black.png";

import clientLogo5 from "../../images/v2/client-logos/urban.png";
import clientLogo6 from "../../images/v2/client-logos/PFE-Technologies@3x.png";
import clientLogo7 from "../../images/v2/client-logos/tech-data-pepper-cloud-customer.png";
import clientLogo8 from "../../images/v2/client-logos/ptc-data-management-pepper-cloud-customer.png";
import clientLogo9 from "../../images/v2/client-logos/germaxco-shipping-agencies-pte-ltd-pepper-cloud-client.png";
import clientLogo10 from "../../images/v2/client-logos/smf.png";
import clientLogo11 from "../../images/v2/client-logos/cuscapi-singapore-pte-ltd-pepper-cloud-customer.png";
import clientLogo12 from "../../images/v2/client-logos/the-supreme-hr-advisory-pepper-cloud-customer.png";

import React from "react";
import { Box } from "@material-ui/core";
import useWidth from "../../hooks/useWidth";
import PropTypes from "prop-types";

const CompanyCarousel = ({ className }) => {
  const width = useWidth();

  const clients = [
    {
      name: "EVORICH+Pepper Cloud",
      logo: clientLogo1,
      height: 35,
    },
    {
      name: "Siong Door+Pepper Cloud",
      logo: clientLogo2,
      height: 40,
    },
    {
      name: "Crowe+Pepper Cloud",
      logo: clientLogo3,
      height: 40,
    },
    {
      name: "Caffeine Solutions+Pepper Cloud",
      logo: clientLogo4,
      height: 35,
    },
    {
      name: "Urban Mood+Pepper Cloud",
      logo: clientLogo5,
      height: 35,
    },
    {
      name: "PFE Technologies+Pepper Cloud",
      logo: clientLogo6,
      height: 70,
    },
    {
      name: "TechData Corporation+Pepper Cloud",
      logo: clientLogo7,
      height: 35,
    },
    {
      name: "PTC Data Management+Pepper Cloud",
      logo: clientLogo8,
      height: 35,
    },
    {
      name: "Germaxco+Pepper Cloud",
      logo: clientLogo9,
      height: 35,
    },
    {
      name: "Singapore Maritime Foundation+Pepper Cloud",
      logo: clientLogo10,
      height: 35,
    },
    {
      name: "cuscapi - Pepper Cloud customer",
      logo: clientLogo11,
      height: 35,
    },
    {
      name: "The Supreme HR Advisory+Pepper Cloud",
      logo: clientLogo12,
      height: 35,
    },
  ];

  const slidesOnWidth = {
    sm: 3,
    xs: 2,
    md: 4,
    lg: 5,
    xl: 5,
  };

  return (
    <Carousel
      animationSpeed={1000}
      plugins={[
        "infinite",
        "fastSwipe",
        "infinite",
        {
          resolve: slidesToShowPlugin,
          options: {
            numberOfSlides: slidesOnWidth[width],
          },
        },
        {
          resolve: autoplayPlugin,
          options: {
            interval: 2000,
          },
        },
      ]}
    >
      {clients.map(({ name, logo, ...props }) => (
        <Box
          alt={name}
          className={className}
          component="img"
          key={name}
          maxWidth="100%"
          src={logo}
          {...props}
        />
      ))}
    </Carousel>
  );
};

CompanyCarousel.propTypes = {
  className: PropTypes.string,
};

export default CompanyCarousel;
